import { Button } from 'react-bootstrap';

import './styles.css';

interface MessageBubbleProps {
  messageContent: string;
  messageSent: boolean | undefined;
  messageSending?: boolean;
  onResendMessage: () => void;
  creationDate: Date;
}

function MessageBubble({
  creationDate,
  messageContent,
  messageSent,
  messageSending,
  onResendMessage,
}: MessageBubbleProps) {
  const creationDateLabel = new Date(creationDate).toLocaleString('en-US');

  const renderStatus = () => {
    if (messageSending) {
      return 'sending...';
    }
    if (messageSent === false) {
      return (
        <Button
          size="sm"
          variant="link"
          className="ms-auto me-2 p-0 justify-content-end text-capitalize resend-btn"
          onClick={onResendMessage}
        >
          resend message
        </Button>
      );
    }
    return creationDateLabel;
  };

  return (
    <div className="message-bubble">
      <p>{messageContent}</p>
      <div className="creation-date">{renderStatus()}</div>
    </div>
  );
}

export default MessageBubble;
